export enum ERRORS {
  INSUFFICIENT_BALANCE = `Insufficient wallet balance to proceed transaction.`,
  USER_REJECTED = "user rejected transaction",
  WRONG_NETWORK = "Wrong network. Please switch the network and try again.",
  UNKNOWN_ERROR = `Error occured while processing transaction.`,
}
